import { useState, type FormEvent } from 'react';

export interface ContributionFormValues {
  contribution_date: string;
  employer_amount: string;
  employee_amount: string;
  interest_amount: string;
  reference: string;
  notes: string;
}

export const emptyContributionForm: ContributionFormValues = {
  contribution_date: '',
  employer_amount: '',
  employee_amount: '',
  interest_amount: '',
  reference: '',
  notes: '',
};

interface ContributionFormProps {
  initial: ContributionFormValues;
  errors: Record<string, string[]>;
  onCancel: () => void;
  onSubmit: (values: ContributionFormValues) => void;
}

export function ContributionForm({ initial, errors, onCancel, onSubmit }: ContributionFormProps) {
  const [values, setValues] = useState(initial);

  return (
    <form
      className="form-grid"
      onSubmit={(e: FormEvent) => {
        e.preventDefault();
        onSubmit(values);
      }}
    >
      {errors.general && <div className="alert alert-error span-2">{errors.general[0]}</div>}
      <label>
        Date *
        <input
          type="date"
          value={values.contribution_date}
          onChange={(e) => setValues({ ...values, contribution_date: e.target.value })}
          required
        />
        {errors.contribution_date && <small className="error">{errors.contribution_date[0]}</small>}
      </label>
      <label>
        Reference
        <input value={values.reference} onChange={(e) => setValues({ ...values, reference: e.target.value })} />
        {errors.reference && <small className="error">{errors.reference[0]}</small>}
      </label>
      <label>
        Employer amount
        <input
          type="number"
          min="0"
          step="0.01"
          value={values.employer_amount}
          onChange={(e) => setValues({ ...values, employer_amount: e.target.value })}
        />
        {errors.employer_amount && <small className="error">{errors.employer_amount[0]}</small>}
      </label>
      <label>
        Employee amount
        <input
          type="number"
          min="0"
          step="0.01"
          value={values.employee_amount}
          onChange={(e) => setValues({ ...values, employee_amount: e.target.value })}
        />
        {errors.employee_amount && <small className="error">{errors.employee_amount[0]}</small>}
      </label>
      <label>
        Interest credited
        <input
          type="number"
          min="0"
          step="0.01"
          value={values.interest_amount}
          onChange={(e) => setValues({ ...values, interest_amount: e.target.value })}
        />
        {errors.interest_amount && <small className="error">{errors.interest_amount[0]}</small>}
      </label>
      <label className="span-2">
        Notes
        <textarea rows={2} value={values.notes} onChange={(e) => setValues({ ...values, notes: e.target.value })} />
        {errors.notes && <small className="error">{errors.notes[0]}</small>}
      </label>
      <div className="form-actions span-2">
        <button type="button" className="btn btn-ghost" onClick={onCancel}>
          Cancel
        </button>
        <button className="btn btn-primary" disabled={!values.contribution_date}>
          Save
        </button>
      </div>
    </form>
  );
}
